import React from "react";
import Modal from "react-bootstrap/Modal";
import { Bounce, toast } from "react-toastify";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface SupplierModalProps {
  show: boolean;
  onHide: () => void;
  status: string | null;
  title: string | null;
  IdUser: number;
  IdOEM: number;
  updateOEMList: () => Promise<void>;
}

const DeleteOEMModal: React.FC<SupplierModalProps> = ({
  show,
  onHide,
  status,
  title,
  IdUser,
  IdOEM,
  updateOEMList,
}) => {
  const deleteSupplier = async (id_supplier: number, id_user: number) => {
    try {
      const res = await fetch(
        `${backendUrl}/api/delete/${id_supplier}/${id_user}`,
        {
          method: "DELETE",
        },
      );

      onHide();

      if (!res.ok) {
        const details = `Delete supplier: ${id_supplier}`;

        const timestamp = new Date(Date.now() + 60 * 60 * 1000)
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");

        await fetch(`${backendUrl}/api/log-user-action/${id_user}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "Delete",
            page: "Suppliers",
            operation: "Delete",
            timestamp,
            details,
          }),
        });

        toast.warn("Can't delete supplier", {
          position: "bottom-right",
          autoClose: 2500,
          theme: "light",
          transition: Bounce,
        });

        return;
      }

      if (res.ok) {
        updateOEMList();

        toast.success("Supplier deleted successfully!", {
          position: "bottom-right",
          autoClose: 2500,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error("Error deleting supplier", error);

      toast.warn("Can't delete supplier", {
        position: "bottom-right",
        autoClose: 2500,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 600, color: "#495057" }}>
          {title || ""}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center py-4">
        <p
          style={{
            margin: 0,
            fontSize: "1.05rem",
            fontWeight: 500,
            color: "#212529",
          }}
        >
          {status || ""}
        </p>

        <p
          style={{
            margin: "0.6rem 0 0",
            color: "#6c757d",
            fontSize: "0.95rem",
          }}
        >
          This action cannot be undone.
        </p>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <button
          className="btn btn-outline-secondary px-4"
          onClick={onHide}
        >
          Cancel
        </button>

        <button
          className="btn btn-danger px-4"
          onClick={() => deleteSupplier(IdOEM, IdUser)}
        >
          Delete
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteOEMModal;
